// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page{
    /* text-align: center; */
    transition: width 0.3s linear;
    /* //overflow-y:scroll; */
    width: 100%;
    padding-block-start: 40px;
    padding-bottom: 0px;
    height:calc(100vh - 50px);
    overflow-x: hidden;
    scrollbar-width: thin;
}
.left-label h5{
    text-align: center;
    font-size: 20px;
    font-family: Mulish, sans-serif;
    font-weight: 600;
}
.left-label {
    /* // display: flex; */
     flex-direction: row;
     justify-content: space-between;
     align-items: center;
     color: white;
     width: 100%;
     white-space: nowrap; /* Add this line to prevent line breaks */
     overflow: hidden; /* Add this line to hide overflowing text */
     text-overflow: ellipsis; /* Add this line to show ellipsis for long text */
   
   }
.shift_card{
    padding: 15px;
    /* // background: url(../../../assets/images/bg_login.jpg) no-repeat; */
    width: 800px;
    margin-bottom: 15px;
    background: #f7941e;
    text-align: center;
    color: #fff;
    margin: auto;
    position: relative;
    height: auto;
}
.shift{
    .edit{
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }
   
    h2{
        font-size: 1.5rem;
        margin-bottom: 0;
    }
    h3{
        font-size: 70px;
        font-weight: 100;
        margin: 20px 0;
    }
    .status_icon{
          -webkit-display: flex;
-moz-display: flex;
-ms-display: flex;
-o-display: flex;
 display: flex;
 -moz-justify-content: space-around;
 -ms-justify-content: space-around;
 -o-justify-content: space-around;
justify-content: space-around;
        .status{
            width: calc(100% /1);
            &:first-child{
                border-right: 1px solid #ccc;
            }
            span{
                color: #292929;
                font-size: 24px;
            }
            p{
                margin-top: 0px;
                font-size: 18px;
            
        }
        }
     
    }

}

.volkomn{
width:100px;
margin:auto;
}  
.right-label{
    /* // width: calc(135% /2); */
      /* margin: auto !important; */
      margin-left:55px;
      padding: 0;
}
     .shift-content{
      flex-direction: row;
      justify-content: space-between;
     display: flex;
     width:900px;
     margin:auto;
     }
    
     .card_sec {
        border-radius: 0;
        margin-top: 5px;
      
        table {
            font-size: 0.9em;
            color: #666;
            position: relative;
            overflow-x: auto;
            /* z-index: 1200; */
    
            td {
                /* // background-color: #1d1e23; */
                font-size: 12px;
                color: #F1F1F1;
            }
          
            thead {
                th {
                    position: sticky;
                    border: unset;
                    background-color: #071637;
                    font-size:18px;
                    font-weight: 500;
                    color: #fff;
                    font-family: 'Barlow Condensed', sans-serif;
                    line-height: 20px;
                    padding: 0.75rem;
                    &.mat-header-cell {
                        &:first-of-type {
                            padding-left: 8px;
                        }
                    }
                }
            }
    
            tr {
                height: 35px !important;
                background-color: #3b25e6 !important;
    
                td {
                    font-size: 14px;
                    color: #F1F1F1;
                    padding: 0.75rem;
                    border-bottom: none;
                    &.mat-cell,
                    &.mat-footer-cell {
                        /* // border-bottom: 1px solid #777b85; */
                            border-bottom: transparent;
                        &:first-of-type {
                            padding-left: 8px;
                        }
                    }
    
                }
            }
        }
    
        .mat-paginator-container {
            -moz-justify-content: space-between;
            -ms-justify-content: space-between;
            -o-justify-content: space-between;
            justify-content: space-between !important;
            padding: 0 15px!important;
    
            button {
                padding: 0.5rem 0.75rem;
                line-height: 1.25;
    
                background-color: #2e2e2e;
                border: 0;
                border-radius: 0;
                display: inline-block;
                position: relative;
    
                &.mat-paginator-navigation-previous {
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                }
    
                &.mat-paginator-navigation-next {
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                }
    
                &:hover {
                    color: #3b25e6;
                    text-decoration: none;
                    cursor: pointer;
                    background-color: #2e2e2edb;
                    border-color: #ddd;
                }
    
                span {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
    
                    svg {
                        fill: #ec6e17;
                    }
                }
            }
    
        }
    }
    .example-container {
        height: 65vh;
        overflow: auto;
        scrollbar-width: thin;
        background: #abafa1;


      }
      .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.card_sec.css-bhp9pd-MuiPaper-root-MuiCard-root {
        /* Your CSS rules here */
        border:2px solid white;
      }
    .pagecontent{
        display: flex;
        flex-direction: column;
        align-items: center;
    
    }
    .odd-row {
        background-color:#373737;
      }
      
      .even-row {
        background-color:#282828;
      }
      table td {
        border-bottom: none; /* Remove the right border */
      }
      
      table tr {
        border-bottom: none; /* Remove the bottom border */
      }
     /* ... previous styles ... */

/* ... previous styles ... */

@media (max-width: 768px) {
    .shift_card {
      width: 70%;
      position: static;
    }
  
    .shift-content {
      flex-direction: column;
      width: 100%;
    }
  
    .right-label {
      margin: 20px 0 !important;
      /* margin-left: 55px; */
    }
  
    .page {
      padding-left: 15px; /* Add some padding to the left */
      padding-right: 15px; /* Add some padding to the right */
    }
  }
  
  @media (max-width: 480px) {
    .shift_card {
      /* width: 100%;
      margin: 10px;
      box-sizing: border-box; */
      display: none;
    }
  
    /* .shift-content {
      flex-direction: column;
      align-items: center;
    } */
  
    .right-label {
      width: 100%;
      margin: 20px 0 !important;
    }
  
    .page {
      padding-left: 10px; /* Reduce the left padding for smaller screens */
      padding-right: 10px; /* Reduce the right padding for smaller screens */
    }
  }
 /* styles.css */
.machinedialog.mat-mdc-form-field-infix {
  flex: auto;
  min-width: 0;
  width: 180px;
  position: relative;
  background-color: grey;
  box-sizing: border-box;
}
.machinedialog.mat-form-field-appearance-outline .mat-form-field-outline {
  background-color: #666 !important;
  border-radius: 5px;
  border: unset;
}
.machinedialog .mat-form-field-appearance-outline .mat-form-field-outline {
  background-color: #202739 !important;
  border-radius: 5px;
  border: unset;
}
.form_sec_fields .form_field {
  width: 32%;
  margin-right: 10px;
  margin-bottom: 10px;
}
.form_sec_fields .form_field.time_field_bg, .time_field_bg {
  background: #202739;
  padding: 30px;
  border-radius: 20px;

  
}

.form_sec_fields{
  -webkit-display: flex;
-moz-display: flex;
-ms-display: flex;
-o-display: flex;
display: flex;
-o-flex-wrap: wrap;
flex-wrap: wrap;
align-items: flex-end;
margin-left: 15px ;
.form_field {
width: 31%;
margin-right: 10px;
margin-bottom: 10px;
}
.ngb-tp-input {
padding: 0;
font-size: 28px;

}

}
.shift_form .form_field {
  margin-bottom: 20px;
  margin-right: 10px;
}
.css-e784if-MuiTypography-root {
  color: white;
}
.close_modal {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #a3a0a0;
    mat-icon {
        font-size: 20px;
        color: #0e121b;
        background-color:white;
        align-items: center;

    }
}
.error-message {
  color: red;
  font-size: 0.75rem;
}
.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding-right: 32px;
  color: white;
}
 @media screen and (max-width:600px){
  .form_field {
    width: 100%;
    margin-right: 10px;
    margin-bottom: 10px;
    }
    .form_sec_fields{
      flex-direction: column;
    }
    .form_sec_fields .form_field.time_field_bg, .time_field_bg {
     width:100%;
    
      
    }
    .form_sec_fields .form_field {
      width: 100%;
      margin-right: 10px;
      margin-bottom: 10px;
    }
 }
 /* .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
  color: white !important;
 } */
 .error-outline .MuiOutlinedInput-notchedOutline,
.error-outline .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
.error-outline .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: red !important;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/Pages/Shift/shift.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,sBAAsB;KACrB,mBAAmB;KACnB,8BAA8B;KAC9B,mBAAmB;KACnB,YAAY;KACZ,WAAW;KACX,mBAAmB,EAAE,yCAAyC;KAC9D,gBAAgB,EAAE,2CAA2C;KAC7D,uBAAuB,EAAE,iDAAiD;;GAE5E;AACH;IACI,aAAa;IACb,uEAAuE;IACvE,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;IACA;UACM,qBAAqB;AAC/B,kBAAkB;AAClB,iBAAiB;AACjB,gBAAgB;CACf,aAAa;CAEb,kCAAkC;CAClC,iCAAiC;CACjC,gCAAgC;AACjC,6BAA6B;QACrB;YACI,oBAAoB;YACpB;gBACI,4BAA4B;YAChC;YACA;gBACI,cAAc;gBACd,eAAe;YACnB;YACA;gBACI,eAAe;gBACf,eAAe;;QAEvB;QACA;;IAEJ;;AAEJ;;AAEA;AACA,WAAW;AACX,WAAW;AACX;AACA;IACI,6BAA6B;MAC3B,6BAA6B;MAC7B,gBAAgB;MAChB,UAAU;AAChB;KACK;MACC,mBAAmB;MACnB,8BAA8B;KAC/B,aAAa;KACb,WAAW;KACX,WAAW;KACX;;KAEA;QACG,gBAAgB;QAChB,eAAe;;QAEf;YACI,gBAAgB;YAChB,WAAW;YACX,kBAAkB;YAClB,gBAAgB;YAChB,mBAAmB;;YAEnB;gBACI,kCAAkC;gBAClC,eAAe;gBACf,cAAc;YAClB;;YAEA;gBACI;oBACI,gBAAgB;oBAChB,aAAa;oBACb,yBAAyB;oBACzB,cAAc;oBACd,gBAAgB;oBAChB,WAAW;oBACX,2CAA2C;oBAC3C,iBAAiB;oBACjB,gBAAgB;oBAChB;wBACI;4BACI,iBAAiB;wBACrB;oBACJ;gBACJ;YACJ;;YAEA;gBACI,uBAAuB;gBACvB,oCAAoC;;gBAEpC;oBACI,eAAe;oBACf,cAAc;oBACd,gBAAgB;oBAChB,mBAAmB;oBACnB;;wBAEI,yCAAyC;4BACrC,0BAA0B;wBAC9B;4BACI,iBAAiB;wBACrB;oBACJ;;gBAEJ;YACJ;QACJ;;QAEA;YAEI,mCAAmC;YACnC,kCAAkC;YAClC,iCAAiC;YACjC,yCAAyC;YACzC,yBAAyB;;YAEzB;gBACI,uBAAuB;gBACvB,iBAAiB;;gBAEjB,yBAAyB;gBACzB,SAAS;gBACT,gBAAgB;gBAChB,qBAAqB;gBACrB,kBAAkB;;gBAElB;oBACI,2BAA2B;oBAC3B,8BAA8B;gBAClC;;gBAEA;oBACI,4BAA4B;oBAC5B,+BAA+B;gBACnC;;gBAEA;oBACI,cAAc;oBACd,qBAAqB;oBACrB,eAAe;oBACf,2BAA2B;oBAC3B,kBAAkB;gBACtB;;gBAEA;oBACI,kBAAkB;oBAClB,QAAQ;oBACR,SAAS;oBACT,gCAAgC;;oBAEhC;wBACI,aAAa;oBACjB;gBACJ;YACJ;;QAEJ;IACJ;IACA;QACI,YAAY;QACZ,cAAc;QACd,qBAAqB;QACrB,mBAAmB;;;MAGrB;MACA;QACE,wBAAwB;QACxB,sBAAsB;MACxB;IACF;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;;IAEvB;IACA;QACI,wBAAwB;MAC1B;;MAEA;QACE,wBAAwB;MAC1B;MACA;QACE,mBAAmB,EAAE,4BAA4B;MACnD;;MAEA;QACE,mBAAmB,EAAE,6BAA6B;MACpD;KACD,4BAA4B;;AAEjC,4BAA4B;;AAE5B;IACI;MACE,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;MACtB,WAAW;IACb;;IAEA;MACE,yBAAyB;MACzB,uBAAuB;IACzB;;IAEA;MACE,kBAAkB,EAAE,iCAAiC;MACrD,mBAAmB,EAAE,kCAAkC;IACzD;EACF;;EAEA;IACE;MACE;;+BAEyB;MACzB,aAAa;IACf;;IAEA;;;OAGG;;IAEH;MACE,WAAW;MACX,yBAAyB;IAC3B;;IAEA;MACE,kBAAkB,EAAE,gDAAgD;MACpE,mBAAmB,EAAE,iDAAiD;IACxE;EACF;CACD,eAAe;AAChB;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;;;AAGrB;;AAEA;EACE,qBAAqB;AACvB,kBAAkB;AAClB,iBAAiB;AACjB,gBAAgB;AAChB,aAAa;AAIb,kBAAkB;AACjB,eAAe;AAChB,qBAAqB;AACrB,kBAAkB;AAClB;AACA,UAAU;AACV,kBAAkB;AAClB,mBAAmB;AACnB;AACA;AACA,UAAU;AACV,eAAe;;AAEf;;AAEA;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd;QACI,eAAe;QACf,cAAc;QACd,sBAAsB;QACtB,mBAAmB;;IAEvB;AACJ;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;CACC;EACC;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB;IACA;MACE,sBAAsB;IACxB;IACA;KACC,UAAU;;;IAGX;IACA;MACE,WAAW;MACX,kBAAkB;MAClB,mBAAmB;IACrB;CACH;CACA;;IAEG;CACH;;;EAGC,4BAA4B;EAC5B,uBAAuB;AACzB","sourcesContent":[".page{\n    /* text-align: center; */\n    transition: width 0.3s linear;\n    /* //overflow-y:scroll; */\n    width: 100%;\n    padding-block-start: 40px;\n    padding-bottom: 0px;\n    height:calc(100vh - 50px);\n    overflow-x: hidden;\n    scrollbar-width: thin;\n}\n.left-label h5{\n    text-align: center;\n    font-size: 20px;\n    font-family: Mulish, sans-serif;\n    font-weight: 600;\n}\n.left-label {\n    /* // display: flex; */\n     flex-direction: row;\n     justify-content: space-between;\n     align-items: center;\n     color: white;\n     width: 100%;\n     white-space: nowrap; /* Add this line to prevent line breaks */\n     overflow: hidden; /* Add this line to hide overflowing text */\n     text-overflow: ellipsis; /* Add this line to show ellipsis for long text */\n   \n   }\n.shift_card{\n    padding: 15px;\n    /* // background: url(../../../assets/images/bg_login.jpg) no-repeat; */\n    width: 800px;\n    margin-bottom: 15px;\n    background: #f7941e;\n    text-align: center;\n    color: #fff;\n    margin: auto;\n    position: relative;\n    height: auto;\n}\n.shift{\n    .edit{\n        position: absolute;\n        right: 10px;\n        top: 10px;\n        cursor: pointer;\n    }\n   \n    h2{\n        font-size: 1.5rem;\n        margin-bottom: 0;\n    }\n    h3{\n        font-size: 70px;\n        font-weight: 100;\n        margin: 20px 0;\n    }\n    .status_icon{\n          -webkit-display: flex;\n-moz-display: flex;\n-ms-display: flex;\n-o-display: flex;\n display: flex;\n -webkit-justify-content: space-around;\n -moz-justify-content: space-around;\n -ms-justify-content: space-around;\n -o-justify-content: space-around;\njustify-content: space-around;\n        .status{\n            width: calc(100% /1);\n            &:first-child{\n                border-right: 1px solid #ccc;\n            }\n            span{\n                color: #292929;\n                font-size: 24px;\n            }\n            p{\n                margin-top: 0px;\n                font-size: 18px;\n            \n        }\n        }\n     \n    }\n\n}\n\n.volkomn{\nwidth:100px;\nmargin:auto;\n}  \n.right-label{\n    /* // width: calc(135% /2); */\n      /* margin: auto !important; */\n      margin-left:55px;\n      padding: 0;\n}\n     .shift-content{\n      flex-direction: row;\n      justify-content: space-between;\n     display: flex;\n     width:900px;\n     margin:auto;\n     }\n    \n     .card_sec {\n        border-radius: 0;\n        margin-top: 5px;\n      \n        table {\n            font-size: 0.9em;\n            color: #666;\n            position: relative;\n            overflow-x: auto;\n            /* z-index: 1200; */\n    \n            td {\n                /* // background-color: #1d1e23; */\n                font-size: 12px;\n                color: #F1F1F1;\n            }\n          \n            thead {\n                th {\n                    position: sticky;\n                    border: unset;\n                    background-color: #071637;\n                    font-size:18px;\n                    font-weight: 500;\n                    color: #fff;\n                    font-family: 'Barlow Condensed', sans-serif;\n                    line-height: 20px;\n                    padding: 0.75rem;\n                    &.mat-header-cell {\n                        &:first-of-type {\n                            padding-left: 8px;\n                        }\n                    }\n                }\n            }\n    \n            tr {\n                height: 35px !important;\n                background-color: #3b25e6 !important;\n    \n                td {\n                    font-size: 14px;\n                    color: #F1F1F1;\n                    padding: 0.75rem;\n                    border-bottom: none;\n                    &.mat-cell,\n                    &.mat-footer-cell {\n                        /* // border-bottom: 1px solid #777b85; */\n                            border-bottom: transparent;\n                        &:first-of-type {\n                            padding-left: 8px;\n                        }\n                    }\n    \n                }\n            }\n        }\n    \n        .mat-paginator-container {\n            -webkit-justify-content: space-between;\n            -moz-justify-content: space-between;\n            -ms-justify-content: space-between;\n            -o-justify-content: space-between;\n            justify-content: space-between !important;\n            padding: 0 15px!important;\n    \n            button {\n                padding: 0.5rem 0.75rem;\n                line-height: 1.25;\n    \n                background-color: #2e2e2e;\n                border: 0;\n                border-radius: 0;\n                display: inline-block;\n                position: relative;\n    \n                &.mat-paginator-navigation-previous {\n                    border-top-left-radius: 5px;\n                    border-bottom-left-radius: 5px;\n                }\n    \n                &.mat-paginator-navigation-next {\n                    border-top-right-radius: 5px;\n                    border-bottom-right-radius: 5px;\n                }\n    \n                &:hover {\n                    color: #3b25e6;\n                    text-decoration: none;\n                    cursor: pointer;\n                    background-color: #2e2e2edb;\n                    border-color: #ddd;\n                }\n    \n                span {\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n    \n                    svg {\n                        fill: #ec6e17;\n                    }\n                }\n            }\n    \n        }\n    }\n    .example-container {\n        height: 65vh;\n        overflow: auto;\n        scrollbar-width: thin;\n        background: #abafa1;\n\n\n      }\n      .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.card_sec.css-bhp9pd-MuiPaper-root-MuiCard-root {\n        /* Your CSS rules here */\n        border:2px solid white;\n      }\n    .pagecontent{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    \n    }\n    .odd-row {\n        background-color:#373737;\n      }\n      \n      .even-row {\n        background-color:#282828;\n      }\n      table td {\n        border-bottom: none; /* Remove the right border */\n      }\n      \n      table tr {\n        border-bottom: none; /* Remove the bottom border */\n      }\n     /* ... previous styles ... */\n\n/* ... previous styles ... */\n\n@media (max-width: 768px) {\n    .shift_card {\n      width: 70%;\n      position: static;\n    }\n  \n    .shift-content {\n      flex-direction: column;\n      width: 100%;\n    }\n  \n    .right-label {\n      margin: 20px 0 !important;\n      /* margin-left: 55px; */\n    }\n  \n    .page {\n      padding-left: 15px; /* Add some padding to the left */\n      padding-right: 15px; /* Add some padding to the right */\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .shift_card {\n      /* width: 100%;\n      margin: 10px;\n      box-sizing: border-box; */\n      display: none;\n    }\n  \n    /* .shift-content {\n      flex-direction: column;\n      align-items: center;\n    } */\n  \n    .right-label {\n      width: 100%;\n      margin: 20px 0 !important;\n    }\n  \n    .page {\n      padding-left: 10px; /* Reduce the left padding for smaller screens */\n      padding-right: 10px; /* Reduce the right padding for smaller screens */\n    }\n  }\n /* styles.css */\n.machinedialog.mat-mdc-form-field-infix {\n  flex: auto;\n  min-width: 0;\n  width: 180px;\n  position: relative;\n  background-color: grey;\n  box-sizing: border-box;\n}\n.machinedialog.mat-form-field-appearance-outline .mat-form-field-outline {\n  background-color: #666 !important;\n  border-radius: 5px;\n  border: unset;\n}\n.machinedialog .mat-form-field-appearance-outline .mat-form-field-outline {\n  background-color: #202739 !important;\n  border-radius: 5px;\n  border: unset;\n}\n.form_sec_fields .form_field {\n  width: 32%;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n.form_sec_fields .form_field.time_field_bg, .time_field_bg {\n  background: #202739;\n  padding: 30px;\n  border-radius: 20px;\n\n  \n}\n\n.form_sec_fields{\n  -webkit-display: flex;\n-moz-display: flex;\n-ms-display: flex;\n-o-display: flex;\ndisplay: flex;\n -webkit-flex-wrap: wrap;\n-moz-flex-wrap: wrap;\n-ms-flex-wrap: wrap;\n-o-flex-wrap: wrap;\n flex-wrap: wrap;\nalign-items: flex-end;\nmargin-left: 15px ;\n.form_field {\nwidth: 31%;\nmargin-right: 10px;\nmargin-bottom: 10px;\n}\n.ngb-tp-input {\npadding: 0;\nfont-size: 28px;\n\n}\n\n}\n.shift_form .form_field {\n  margin-bottom: 20px;\n  margin-right: 10px;\n}\n.css-e784if-MuiTypography-root {\n  color: white;\n}\n.close_modal {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    color: #a3a0a0;\n    mat-icon {\n        font-size: 20px;\n        color: #0e121b;\n        background-color:white;\n        align-items: center;\n\n    }\n}\n.error-message {\n  color: red;\n  font-size: 0.75rem;\n}\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding-right: 32px;\n  color: white;\n}\n @media screen and (max-width:600px){\n  .form_field {\n    width: 100%;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    }\n    .form_sec_fields{\n      flex-direction: column;\n    }\n    .form_sec_fields .form_field.time_field_bg, .time_field_bg {\n     width:100%;\n    \n      \n    }\n    .form_sec_fields .form_field {\n      width: 100%;\n      margin-right: 10px;\n      margin-bottom: 10px;\n    }\n }\n /* .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\n  color: white !important;\n } */\n .error-outline .MuiOutlinedInput-notchedOutline,\n.error-outline .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,\n.error-outline .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: red !important;\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
